import React from 'react';
import { HiMenu } from '../icons';
import { ThemeToggle } from '../ui/ThemeToggle';

interface TopBarProps {
  onToggleSidebar: () => void;
  sidebarCollapsed: boolean;
}

export function TopBar({ onToggleSidebar, sidebarCollapsed }: TopBarProps) {
  return (
    <header
      className={`
        fixed top-0 right-0 z-30 h-16
        bg-white/80 dark:bg-xtnd-dark-900/80 backdrop-blur-lg
        border-b border-xtnd-dark-200 dark:border-xtnd-dark-700
        transition-all duration-300
        ${sidebarCollapsed ? 'left-20' : 'left-72'}
      `}
    >
      <div className="h-full flex items-center justify-between px-6">
        {/* Left: Toggle Sidebar Button + Title */}
        <div className="flex items-center gap-4">
          <button
            onClick={onToggleSidebar}
            className="
              group p-2.5 rounded-xl
              bg-xtnd-dark-100 dark:bg-xtnd-dark-700
              hover:bg-xtnd-dark-800 hover:text-white dark:hover:bg-xtnd-blue
              transition-all duration-200
              shadow-sm hover:shadow-md
            "
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <HiMenu className="h-5 w-5 text-xtnd-dark-700 dark:text-white group-hover:text-white transition-colors" />
          </button>

          <div className="flex flex-col">
            <span className="text-lg font-bold text-xtnd-dark-800 dark:text-white leading-tight">
              XTND Admin
            </span>
            <span className="text-xs text-xtnd-dark-400 dark:text-xtnd-dark-300">
              Platform Administration
            </span>
          </div>
        </div>

        {/* Right: Theme Toggle */}
        <div className="flex items-center gap-3">
          <ThemeToggle size="sm" showLabels={false} />
        </div>
      </div>
    </header>
  );
}
